import { RepaymentLoans } from "components/Dashboard/Home/RepaymentLoans";
import AuthLayout from "layout/AuthLayout";

export default function RepaymentPage(){
    return(
        <AuthLayout>
           <div className="px-4 py-10">
            <RepaymentLoans/>
           </div>
        </AuthLayout>
    )
}